//REDUX-TOOLKIT
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface State {
    data: object[]
}

const initialState: State = {
    data: []
}


const slice = createSlice({
    name: "feature",
    initialState,
    reducers: {
        setFeature: (state, action: PayloadAction<any>) => {
            return { ...state, data: action.payload }
        }
    }
})


export const { setFeature } = slice.actions;
export const selectFeature = (state: { feature: State }) => state.feature.data;
export default slice.reducer;